import { useContext } from 'react';
import RedirectToDashboardContext, {
  RedirectToDashboardContextValue,
} from 'ui/components/RedirectToDashboardProvider/RedirectToDashboardContext';

const useRedirectToDashboard = (): RedirectToDashboardContextValue => {
  const context = useContext(RedirectToDashboardContext);

  if (!context)
    throw new Error(
      'useRedirectToDashboard must be used inside RedirectToDashboardContext',
    );

  return context;
};

export default useRedirectToDashboard;
